import {Link, useLocation} from "react-router-dom";
import {Breadcrumb, Space} from "antd";
import "./Breadcrumb.css";
import {RoutingURL, StatusCodeE} from "../../../../model/models";


export function Breadcrumbs() {
    const location = useLocation();
    const pathSnippets: string[] = location.pathname.split('/').filter(i => i);

    // Define breadcrumb name mapping for static paths
    const breadcrumbNameMap: { [key: string]: string } = {
        [RoutingURL.HOME]: "Home",
        [RoutingURL.SCRIVANIA]: "Scrivania Da Lavoro",
        [RoutingURL.CRUSCOTTO]: "Cruscotto",
        [RoutingURL.DOSSIER]: "Fascicolo",
        [RoutingURL.SETTINGS]: "Amministrazione"
    };

    const extraBreadcrumbItems = pathSnippets.map((value: string, index: number) => {
        let url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
        let key = url;

        let isClickable = true;
        if (url.startsWith("/Fascicolo/DettagliUtente") || url.startsWith("/ScrivaniaDaLavoro/") || url.includes("/Cruscotto")) {
            isClickable = false;
        }

        let breadcrumbLabel = breadcrumbNameMap[key] || value;

        if (breadcrumbLabel.includes("DettagliUtente")) {
            breadcrumbLabel = breadcrumbLabel.replace("DettagliUtente", "Dettagli Utente");
        }
        if (breadcrumbLabel.includes("ReportChiamate")) {
            breadcrumbLabel = breadcrumbLabel.replace("ReportChiamate", "Report Chiamate");
        }
        if (breadcrumbLabel.includes("Attivita")) {
            breadcrumbLabel = breadcrumbLabel.replace("Attivita", "Attività");
        }

        if (breadcrumbLabel.includes("Variabili")) {
            breadcrumbLabel = breadcrumbLabel.replace("VariabiliDiCalcolo", "Variabili Di Calcolo");
        }
        if (breadcrumbLabel.includes("ReportRate")) {
            breadcrumbLabel = breadcrumbLabel.replace("ReportRate", "Report Rate");
        }
        if (breadcrumbLabel.includes("ReportIncassi")) {
            breadcrumbLabel = breadcrumbLabel.replace("ReportIncassi", "Report Incassi");
        }
        if (breadcrumbLabel.includes("AvvisoDiMancatoPagamento")) {
            breadcrumbLabel = breadcrumbLabel.replace("AvvisoDiMancatoPagamento", "Avviso Di Mancato Pagamento");
        }
        if (breadcrumbLabel.includes("GestioneUtenti")) {
            breadcrumbLabel = breadcrumbLabel.replace("GestioneUtenti", "Gestione Utenti");
        }

        if (breadcrumbLabel === StatusCodeE.DA_LAVORARE) {
            breadcrumbLabel = "Da Lavorare"
        } else if (breadcrumbLabel === StatusCodeE.IN_LAVORAZIONE) {
            breadcrumbLabel = "In Lavorazione"
        } else if (breadcrumbLabel === StatusCodeE.DA_FIRMARE) {
            breadcrumbLabel = "Da Firmare e Protocollare"
        } else if (breadcrumbLabel === StatusCodeE.NOTIFICA) {
            breadcrumbLabel = "Notifica"
        } else if (breadcrumbLabel === StatusCodeE.ATTESA_PAGAMENTO) {
            breadcrumbLabel = "Attesa Pagamento"
        } else if (breadcrumbLabel === StatusCodeE.PAGATE) {
            breadcrumbLabel = "Pagate"
        } else if (breadcrumbLabel === StatusCodeE.SOSPESE) {
            breadcrumbLabel = "Sospese"
        } else if (breadcrumbLabel === StatusCodeE.SCADUTE) {
            breadcrumbLabel = "Scadute"
        } else if (breadcrumbLabel === StatusCodeE.TRASFERITE) {
            breadcrumbLabel = "Trasferite"
        } else if (breadcrumbLabel === StatusCodeE.DA_TRASFERIRE) {
            breadcrumbLabel = "Da Trasferire"
        } else if (breadcrumbLabel === StatusCodeE.RENDICONTATE) {
            breadcrumbLabel = "Rendicontate in TS"
        } else if (breadcrumbLabel === StatusCodeE.RESIDUE) {
            breadcrumbLabel = "Residue"
        } else if (breadcrumbLabel === StatusCodeE.DA_RENDICONTARE) {
            breadcrumbLabel = "Da Rendicontare in TS"
        } else if (breadcrumbLabel === StatusCodeE.ARCHIVIATE) {
            breadcrumbLabel = "Archiviate"
        }

        return {
            key: key,
            title: isClickable ? <Link to={url}>{breadcrumbLabel}</Link> : breadcrumbLabel,
        };
    });

    const breadcrumbItems = [
        {
            key: 'home',
            title: <Link to="/">Home</Link>,
        },
        ...extraBreadcrumbItems,
    ];

    return (
        <Space className={"breadcrumbs-container"}>
            {breadcrumbItems.length > 1 && <Breadcrumb items={breadcrumbItems}/>}
        </Space>
    );
}
